const tables = [
  {
    name: "Code",
  },
  {
    name: "Name",
  },
  {
    name: "Email",
  },
  {
    name: "Phone",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
